import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { usePremiumAccess } from "../../hooks/usePremiumAccess";
import ProgressLoader from "../layout/ProgressLoader";
var allowedRoutes = [
    "/subscription",
    "/checkout",
];
var PrivateRoute = function (_a) {
    var children = _a.children;
    var navigate = useNavigate();
    var location = useLocation();
    var _b = usePremiumAccess(), hasPremiumAccess = _b.hasPremiumAccess, isLoading = _b.isLoading;
    var isAllowedRoute = allowedRoutes.some(function (route) {
        return location.pathname.startsWith(route);
    });
    useEffect(function () {
        if (!isLoading && !hasPremiumAccess && !isAllowedRoute) {
            console.log(isLoading, hasPremiumAccess, isAllowedRoute);
            navigate("/subscription");
        }
    }, [hasPremiumAccess, isAllowedRoute, navigate, isLoading]);
    if (isLoading) {
        return React.createElement(ProgressLoader, { message: "Verificando acesso..." });
    }
    return children;
};
export default PrivateRoute;
